skrilla.service('entityNoteService', function($q, searchService) {

    let notes = [];

    let getNoteCategories = function () {
        if (notes.length === 0) {
            return searchService.get("entityNotes/categories").then(function (response) {
                notes = response.data;
                return notes;
            });
        }
        return Promise.resolve(notes);
    };

    let formatEntityTitle = function (type) {
        return type.toLowerCase().replace(/_/g, ' ')
            .replace(/\b\w/g, firstLetter => firstLetter.toUpperCase());
    };

    return {
        getNoteCategories: getNoteCategories,
        formatEntityTitle: formatEntityTitle
    };

});